import { Inject, Injectable, DOCUMENT } from '@angular/core';

import { animate, AnimationBuilder, AnimationPlayer, style } from '@angular/animations';

@Injectable({
    providedIn: 'root'
})
export class FuseSplashScreenService
{
    splashScreenEl: any;
    player: AnimationPlayer;
    private splashHidden = false;

    /**
     * Constructor
     *
     * @param {AnimationBuilder} _animationBuilder
     * @param _document
     */
    constructor(
        private _animationBuilder: AnimationBuilder,
        @Inject(DOCUMENT) private _document: any,
    )
    {}

    public init(): void
    {
        this.splashScreenEl = this._document.body.querySelector('#u2b-splash-screen');

        if ( !this.splashScreenEl )
        {
            return;
        }

        // AppComponent is only created after APP_INITIALIZER (auth/Tolgee) finished.
        // Do not wait for NavigationEnd: BcmAuthGuard may cancel navigation while Keycloak login
        // starts, and the fade-out animation previously reset opacity back to 1.
        this.scheduleHide();
    }

    private scheduleHide(): void
    {
        if ( this.splashHidden || !this.splashScreenEl )
        {
            return;
        }
        this.splashHidden = true;
        setTimeout(() => {
            this.hide();
        });
    }

    show(opacity = 1): void
    {
        this.player =
            this._animationBuilder
                .build([
                    style({
                        opacity: '0',
                        zIndex : '99999'
                    }),
                    animate('400ms ease', style({opacity}))
                ]).create(this.splashScreenEl);

        setTimeout(() => {
            this.player.play();
        }, 0);
    }

    hide(): void
    {
        if ( !this.splashScreenEl )
        {
            return;
        }

        this.splashScreenEl.style.opacity = '0';
        this.splashScreenEl.style.zIndex = '-10';
        this.splashScreenEl.style.pointerEvents = 'none';
        this.splashScreenEl.style.display = 'none';
    }
}
